/**
 * Main entry point for Smartoolery theme JavaScript
 */
import Navigation from './components/navigation.js';

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Initialize navigation
    new Navigation();

    console.log('Smartoolery theme initialized');
});
